import React from 'react';
import { IIconProps } from '../../interfaces';
const TwitchIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 35 36"  fill="none" >
          <title>{props.title}</title>

          <path d="M17.1996 18.5497H14.1086V9.27547H17.1996V18.5497Z" fill="black"/>
          <path d="M22.6089 18.5497H25.6987V9.27547H22.6089V18.5497Z" fill="black"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M0.200195 6.18324L2.51846 0H34.2002V21.642L24.9259 30.9126H17.9723L13.337 35.5527H8.69809V30.9126H0.200195V6.18324ZM31.1104 3.08981H5.60707V25.5045H12.5667V30.1374L17.1996 25.5045H25.6987L31.1104 20.0928V3.08981Z" fill="black"/>
      </svg>


  )
};

export default TwitchIcon;